/**
 * Finds if cookie exists
 * @param {string} name
 * @returns {boolean} result
 */
export const getCookie = (name) => {
  const cookieDecoded = decodeURIComponent(document.cookie);
  const cookies = cookieDecoded.split('; ');
  let result = false;

  cookies.forEach(cookie => {
    if (cookie.indexOf(name) === 0) {
      result = cookie.substring(name.length);
    }
  })

  return result;
}

/**
 * Takes in three arguments to set cookie
 * @param {string} name
 * @param {boolean} value
 * @param {number} days
 */
export const setCookie = (name, value, days) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);

  const cookieName = `${name}=${value}`;
  const expires = `expires=${date.toUTCString()}`;

  document.cookie = `${cookieName}; ${expires}; path=/`;
}

/**
 * Check if cookie exists to display Age Gate modal
 * @param {string} name
 * @param {boolean} modalResult
 * @param {any} setModalResult
 * @returns {boolean} result
 */
export const checkCookie = (name, modalResult, setModalResult) => {
  const isAgeGateCookie = getCookie(name);
  let result = modalResult;

  if (isAgeGateCookie) {
    result = false;
    setModalResult(result);
  } else {
    document.body.style.overflow = 'hidden';
  }

  return result;
}
